import React, { useMemo } from "react";
import { AuthUserModel } from "app/services/api/types/authorisation/models/AuthUserModel";
import { Text, View } from "react-native";
import { ResidentModel } from "app/services/api/types/residents/models/ResidentModel";
import { Avatar } from "ui/atoms/avatar";
import { getFullName } from "ui/utils/nameUtil";

type AvatarProps = {
  user?: Pick<AuthUserModel, "first_name" | "last_name" | "email">;
  resident?: ResidentModel;
};

export const ProfileAvatar: React.FC<AvatarProps> = ({ user, resident }) => {
  const name = getFullName(resident || user);
  const email = user?.email || "";

  const profilePictureSource = useMemo(() => {
    return (
      resident?.profile_picture?.conversions?.small ||
      resident?.profile_picture?.url
    );
  }, [resident]);
  return (
    <View className="flex flex-row gap-x-4 items-center flex-1">
      <Avatar image={profilePictureSource} profile={resident || user}></Avatar>
      <View className="flex flex-col self-center flex-1 ">
        <Text className="font-medium overflow-hidden ">{name}</Text>
        {resident?.room ? (
          <Text className="font-normal text-normal text-xs text-typography-500">
            {resident.room.name || resident.room.room_number}
          </Text>
        ) : null}
        <Text className="text-xs text-gray-600 overflow-hidden">{email}</Text>
      </View>
    </View>
  );
};
